import { ABP, eLayoutType } from '@abp/ng.core';

export const GALILEU_CREDENTIAL_BASE_ROUTES: ABP.Route[] = [
  {
    path: '/galileu-credentials',
    iconClass: 'fas fa-file-alt',
    name: '::Menu:GalileuCredentials',
    layout: eLayoutType.application,
    requiredPolicy: 'cargo_fleet.GalileuCredentials',
    breadcrumbText: '::GalileuCredentials',
  },
];
